import CustomAvatar from "@/components/CustomAvatar";
import LoadingSpinner from "@/components/LoadingSpinner";
import MainLayout from "@/lib/layout/MainLayout";
import { useFollowers } from "@/lib/tanstack-query/hooks/useFollowers";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

export const Route = createFileRoute("/_dashboard/followers/$username")({
  component: RouteComponent,
});

function RouteComponent() {
  const { ref, inView } = useInView();
  const { username } = Route.useParams();

  const {
    data: followers,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useFollowers(username);

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView, isLoading]);

  return (
    <>
      <MainLayout.Header headline="Followers"></MainLayout.Header>
      <div className={"divide-border-wu divide-y"}>
        {followers?.pages.flatMap((follower) => {
          return follower.map((follower) => {
            return (
              <Link
                to="/profile/$username"
                key={follower.id}
                params={{
                  username: follower.username,
                }}
                className="hover:bg-button-hover-background-wu flex w-full items-center space-x-3 px-4 py-4 transition-colors md:px-6 dark:text-white"
              >
                <CustomAvatar
                  width="40px"
                  height="40px"
                  name={follower.name}
                  avatarString={follower.avatar}
                  image={follower.image}
                />
                <div className="flex-1 text-left">
                  <div className="font-medium dark:text-white">
                    {follower.name}
                  </div>
                  <div className="text-secondary-text-wu text-sm">
                    @{follower.username}
                  </div>
                </div>
              </Link>
            );
          });
        })}
      </div>
      <div>
        {isLoading ? <LoadingSpinner /> : null}
        {hasNextPage ? <LoadingSpinner ref={ref} /> : null}
      </div>
    </>
  );
}
